// Generated by CoffeeScript 2.4.1
(function() {
  // Libs
  var Promise, SocketController, Weaver, pjson;

  Promise = require('bluebird');

  pjson = require('../package.json');

  Weaver = require('./Weaver');

  SocketController = class SocketController {
    constructor(address, options) {
      var defaultOptions;
      this.address = address;
      this.options = options;
      defaultOptions = {
        reconnection: true,
        rejectUnauthorized: true
      };
      this.options = this.options || defaultOptions;
      this.options.reconnection = true;
      this.options.query = `sdkVersion=${pjson.version}&requiredServerVersion=${pjson.com_weaverplatform.requiredServerVersion}&requiredConnectorVersion=${pjson.com_weaverplatform.requiredConnectorVersion}`;
    }

    requireIO() {
      return require('socket.io-client/dist/socket.io');
    }

    connect() {
      return new Promise((resolve, reject) => {
        this.io = this.requireIO().connect(this.address, this.options);
        this.io.on('socket.shout', function(msg) {
          return Weaver.publish('socket.shout', msg);
        });
        this.io.on('project.freeze', function(project) {
          return Weaver.publish('project.freeze', project);
        });
        this.io.on('project.unfreeze', function(project) {
          return Weaver.publish('project.unfreeze', project);
        });
        return this.io.on('connect', () => {
          return resolve();
        }).on('connect_error', function(err) {
          return reject(err || 'connect_error');
        }).on('connect_timeout', function() {
          return reject('connect_timeout');
        }).on('error', function(err) {
          return reject(err || 'error');
        });
      });
    }

    disconnect() {
      return this.io.disconnect();
    }

    parseBody(body) {
      return JSON.stringify(body);
    }

    getSocket(body) {
      return this.io;
    }

    emit(key, body) {
      return new Promise((resolve, reject) => {
        var emitStart, socket;
        emitStart = Date.now();
        socket = this.getSocket(body);
        body = this.parseBody(body);
        return socket.emit(key, body, (response) => {
          var error;
          if (response == null) {
            return reject(new Error('Emtpy response from socket interaction'));
          } else if ((response.code != null) && (response.message != null)) {
            error = new Error(response.message);
            error.code = response.code;
            return reject(error);
          } else {
            return resolve(response);
          }
          if ((response.times != null)) {
            this._calculateTimestamps(response, emitStart, Date.now());
          }
          return response;
        });
      });
    }

    _calculateTimestamps(response, emitStart, emitEnd) {
      var connToServer, innerServerDelay, sdkToServer, serverToConn, serverToSdk;
      sdkToServer = response.times.serverStart - emitStart;
      innerServerDelay = response.times.serverStartConnector - response.times.serverStart;
      serverToConn = response.times.executionTimeStart - response.times.serverStartConnector;
      connToServer = response.times.serverEnd - response.times.processingTimeEnd;
      serverToSdk = emitEnd - response.times.serverEnd;
      response.totalTime = emitEnd - emitStart;
      response.times = {
        'sdkToServer': sdkToServer,
        'innerServerDelay': innerServerDelay,
        'serverToConn': serverToConn,
        'connToServer': connToServer,
        'serverToSdk': serverToSdk,
        'executionTime': response.times.executionTime,
        'subQueryTime': response.times.subQueryTime, // never set
        'processingTime': response.times.processingTime
      };
      return response;
    }

    GET(path, body) {
      return this.emit(path, body);
    }

    POST(path, body) {
      return this.emit(path, body);
    }

  };

  module.exports = SocketController;

}).call(this);
